const palette = {
  background: {
    footer: '#F6F5F2',
    default: '#f8fafc',
    paper: '#ffffff',
  },
  grey: {
    main: '#3D3B40',
    light: '#EEEDEB',
    dark: '#31304D',
    contrastText: '#FFF'
  },
  hover: {
    options: 'lightblue'
  },

  primary: {
    main: '#2563eb',
    light: '#60a5fa',
    dark: '#1d4ed8',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#7e22ce',
    light: '#a855f7',
    dark: '#6b21a8',
    contrastText: '#ffffff',
  },
  success: {
    main: '#16a34a',
    light: '#22c55e',
    dark: '#15803d',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#d97706',
    light: '#f59e0b',
    dark: '#b45309',
    contrastText: '#ffffff',
  },
  error: {
    main: '#dc2626',
    light: '#ef4444',
    dark: '#b91c1c',
    contrastText: '#ffffff',
  },
  // ADD THIS - Default color palette
  default: {
    main: '#6b7280', // Gray color
    light: '#9ca3af',
    dark: '#4b5563',
    contrastText: '#ffffff',
  },
  // Also add info for completeness
  info: {
    main: '#0ea5e9',
    light: '#38bdf8',
    dark: '#0284c7',
    contrastText: '#ffffff',
  },
  text: {
    primary: '#1f2937',
    secondary: '#6b7280',
  },
  common: {
    black: '#000000',
    white: '#ffffff',
  },
};

export default palette;
